import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, ValidationErrors } from '@angular/forms';


@Component({
    selector: 'validation-message',
    template: require('./validation-message.component.html'),
    styles: [require('./validation-message.component.css')]
})

export class ValidationMessageComponent  {
    @Input() form: FormGroup;
    hasErrorMessage: boolean = false;
    errorMessage: string[];

    public getFormValidationErrors() {
        this.errorMessage = [];
        if (this.form) {
            Object.keys(this.form.controls).forEach(key => {

                const controlErrors: ValidationErrors = this.form.get(key).errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                        this.errorMessage.push(this.getValidationLine(key, keyError));
                    });
                }
            });

            if (this.errorMessage.length > 0)
                this.hasErrorMessage = true;
            else
                this.hasErrorMessage = false;
        }
    }

    public validateForm() {
        Object.keys(this.form.controls).forEach(field => {
            const control = this.form.get(field);
            if (control instanceof FormControl) {
                if (!control.dirty && !control.value) {
                    control.markAsDirty({onlySelf: true});
                    control.updateValueAndValidity();
                }
            } else if (control instanceof FormGroup) {
                this.validateInnerFormFields(control);
            }
        });
    }

    validateInnerFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                if (!control.dirty && !control.value) {
                    control.markAsDirty({onlySelf: true});
                    control.updateValueAndValidity();
                }
            } else if (control instanceof FormGroup) {
                this.validateInnerFormFields(control);
            }
        });
    }

    getValidationLine(key: string, keyError: string) : string {
        return this.translateKey(key) +  this.translateKeyError(keyError);
    }

    translateKey(key: string) : string {
        if (key == 'description') return 'De omschrijving ';
        else if (key == 'index') return 'Het nummer ';
        else if (key == 'actionIndex') return 'Het nummer ';
        else if (key == 'percentage') return 'Het percentage ';
        else if (key == 'btwGroupId') return 'Het btw percentage ';
        else if (key == 'departmentId') return 'De afdeling  ';
        else if (key == 'isActive') return 'Het record ';
        else if (key == 'name') return 'De naam ';
        else if (key == 'barcode') return 'De barcode ';
        else if (key == 'retailPrice') return 'De prijs inclusief btw ';
        else if (key == 'treatmentTime') return 'De werktijd behandeling ';
        else if (key == 'daysFrom') return 'Het aantal dagen vanaf ';
        else if (key == 'daysUntill') return 'Het aantal dagen tot ';
        else if (key == 'discount') return 'De korting ';
        else if (key == 'type') return 'De soort ';
        else if (key == 'discountBtwId') return 'Het btw percentage voor de korting ';
        else if (key == 'lastName') return 'De achternaam ';
        else if (key == 'duration') return 'De tijd van de behandeling ';
        else if (key == 'appointmentLabelId') return 'De soort behandeling ';
        else if (key == 'contractHours') return 'Het aantal contracturen ';
        else if (key == 'mutationDateTime') return 'De ingangsdatum ';
        else if (key == 'caoEntityId') return 'De CAO-groep ';
        else if (key == 'caoExperienceId') return 'Het aantal jaren ervaring bij aanvang ';
        else if (key == 'bsn') return 'Het BSN ';
        else if (key == 'employeeNo') return 'Het personeelsnummer ';
        else if (key == 'oldPassword') return 'Het huidige wachtwoord ';
        else if (key == 'newPassword') return 'Het nieuwe wachtwoord ';
        else if (key == 'newPasswordRepeat') return 'Het nieuwe wachtwoord herhalen ';
        else if (key == 'subject') return 'Het onderwerp ';
        else if (key == 'message') return 'Het bericht ';
        else if (key == 'invoiceDate') return 'De factuurdatum ';
        else if (key == 'invoiceNo') return 'Het factuurnummer ';
        else if (key == 'priceIncl') return 'De prijs incl. ';
        else if (key == 'priceExcl') return 'De prijs excl. ';
        else if (key == 'mutationDateTime') return 'De mutatiedatum ';
        else if (key == 'mutationKind') return 'De mutatiesoort ';
        else if (key == 'mutationGroupId') return 'De mutatiegroep ';
        else if (key == 'mutationAmount') return 'Het bedrag (incl. BTW) ';
        else if (key == 'paymentDateTime') return 'De betaaldatum ';
        else if (key == 'paymentAmount') return 'Het betaalde bedrag ';
        else if (key == 'paymentType') return 'De betaalwijze ';
        else if (key == 'maxAmount') return 'Het maximaal aantal per maand ';
        else if (key == 'endDate') return 'De einddatum ';
        else if (key == 'descriptionShort') return 'De korte omschrijving ';
        else if (key == 'zipcode') return 'De postcode ';
        else if (key == 'housenumber') return 'Het huisnummer ';
        else if (key == 'houseNo') return 'Het huisnummer ';

        return '';
    }

    translateKeyError(keyError: string) : string {
        if (keyError == 'required') return 'is verplicht';
        else if (keyError == 'customRequired') return 'is verplicht';
        else if (keyError == 'indexNotAvailable') return 'is reeds in gebruik';
        else if (keyError == 'descriptionNotAvailable')
            return 'is reeds in gebruik';
        else if (keyError == 'percentageNotAvailable') return 'is reeds in gebruik';
        else if (keyError == 'cannotDeactivate')
            return 'kan niet op inactief worden gezet omdat het nog in gebruik is bij de kassainstellingen';
        else if (keyError == 'daysOverlap')
            return 'overlapt een andere staffelkorting';
        else if (keyError == 'noZeroContractPossible')
            return 'Indien u kiest voor een 0-uren contract, dient u eerst het vaste werktijdenschema leeg te maken.';
        else if (keyError == 'inactivityHasDateOverlap')
            return 'Er is reeds een (in)activiteit gepland in de gekozen periode';
        else if (keyError == 'durationToShort')
            return 'moet minimaal 5 minuten zijn';
        else if (keyError == 'currentPasswordNoMatch') return 'is niet correct';
        else if (keyError == 'newPasswordRepeatMismatch')
            return 'is niet correct herhaald';
        else if (keyError == 'endDateBeforeBegin') return 'De einddatum ligt voor de begindatum';
        else if (keyError == 'endTimeBeforeBegin') return 'De eindtijd ligt voor de begintijd';
        else if (keyError == 'endDateOtherYearAsBegin') return 'De einddatum moet in hetzelfde jaar als de begindatum liggen';

        return '';
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/validation-message.component.ts